import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../../hook/use-http";
import { Chart } from "react-google-charts";
import NoData_Coral from "../NoData_Coral";
import ChartLoader_Coral from "../ChartLoader_Coral";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitialstates_coral";
import BuketsTable_Coral from "../BuketsTable_Coral";
import * as $ from "jquery";

function NetEnergySecondErc_Coral({ apiend, gloablfilter, title }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let modal_title = title;

  const appyData = (data) => {
    const res_result = data;

    let responce = {
      "0-100": 0,
      "100-120": 0,
      "120-140": 0,
      "140-160": 0,
      "160-180": 0,
      "180-200": 0,
      "200-220": 0,
      "220-240": 0,
      "240-260": 0,
      "260-280": 0,
      "280-300": 0,
      "300-320": 0,
      ">=320": 0,
    };
    if (res_result.length != 0) {
      SetApiResponce(res_result);
      let temp_result = res_result;
      temp_result.map((d) => {
        let value = d._source.whPerKM;
        if (value >= 0 && value < 100) {
          responce["0-100"] = responce["0-100"] + 1;
        } else if (value >= 100 && value < 120) {
          responce["100-120"] = responce["100-120"] + 1;
        } else if (value >= 120 && value < 140) {
          responce["120-140"] = responce["120-140"] + 1;
        } else if (value >= 140 && value < 160) {
          responce["140-160"] = responce["140-160"] + 1;
        } else if (value >= 160 && value < 180) {
          responce["160-180"] = responce["160-180"] + 1;
        } else if (value >= 180 && value < 200) {
          responce["180-200"] = responce["180-200"] + 1;
        } else if (value >= 200 && value < 220) {
          responce["200-220"] = responce["200-220"] + 1;
        } else if (value >= 220 && value < 240) {
          responce["220-240"] = responce["220-240"] + 1;
        } else if (value >= 240 && value < 260) {
          responce["240-260"] = responce["240-260"] + 1;
        } else if (value >= 260 && value < 280) {
          responce["260-280"] = responce["260-280"] + 1;
        } else if (value >= 280 && value < 300) {
          responce["280-300"] = responce["280-300"] + 1;
        } else if (value >= 300 && value < 320) {
          responce["300-320"] = responce["300-320"] + 1;
        } else if (value >= 320) {
          responce[">=320"] = responce[">=320"] + 1;
        }
      });

      let res_result_final = [["Element", "Count", { role: "style" }]];
      let loop_keys = Object.keys(responce);
      loop_keys.map((x) => {
        // res_result_final.push([x, responce[x], "#348393"]);
        res_result_final.push([
          x,
          responce[x],
          "stroke-width: 1;stroke-color: black;color:#348393",
        ]);
      });
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
      SetApiResponce((prestate) => []);
    }
  };

  const options = {
    hAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Wh / Km",
      minValue: 0,
      format: "short",
      textStyle: {
        fontSize: 7, // Adjust the font size as needed
      },
      slantedText: true, // Enable slanted text
      slantedTextAngle: 60, // Rotate labels to vertical (90 degrees)
    },
    vAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Discharge Cycle",
      minValue: 0,
      format: "short",
    },
    bar: { groupWidth: "100%" },
    legend: "none",
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + apiend,
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  return (
    <>
      <div className="v-title chartbox drive_graph graph_two p-0">
        <div className="titlebg titlebd_drive box_title pb-2 pt-2">{title}</div>
        <div className="chartHGT">
          {isLoading ? (
            <ChartLoader_Coral />
          ) : chartdata.length === 0 ? (
            <NoData_Coral />
          ) : (
            <Chart
              chartType="ColumnChart"
              width="100%"
              height="240px"
              data={chartdata}
              options={options}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default NetEnergySecondErc_Coral;
